<div class="form-horizontal" [formGroup]="pottingInstructions">
  <div class="form-group" [class.has-error]="pottingInstructions.get('potType').invalid">
    <label class="control-label col-sm-2">Pot Type</label>
    <span class="col-sm-10">
      <select formControlName="potType" class="form-control">
        <option [ngValue]="null"></option>
        <option *ngFor="let option of options.potTypes" [ngValue]="option.id">{{ option.display }}</option>
      </select>
    </span>
  </div>

  <div class="form-group" [class.has-error]="pottingInstructions.get('substrate').invalid">
    <label class="control-label col-sm-2">Substrate</label>
    <span class="col-sm-10">
      <select formControlName="substrate" class="form-control">
        <option [ngValue]="null"></option>
        <option *ngFor="let option of options.substrates" [ngValue]="option.id">{{ option.display }}</option>
      </select>
    </span>
  </div>

  <div class="form-group" [class.has-error]="pottingInstructions.get('irrigation').invalid">
    <label class="control-label col-sm-2">Irrigation</label>
    <span class="col-sm-10">
      <select formControlName="irrigation" class="form-control">
        <option [ngValue]="null"></option>
        <option *ngFor="let option of options.irrigations" [ngValue]="option.id">{{ option.display }}</option>
        </select>
    </span>
  </div>

  <div class="form-group" [class.has-error]="pottingInstructions.get('fertigation').invalid">
    <label class="control-label col-sm-2">Fertigation</label>
    <span class="col-sm-10">
      <select formControlName="fertigation" class="form-control">
        <option [ngValue]="null"></option>
        <option *ngFor="let option of options.fertigations" [ngValue]="option.id">{{ option.display }}</option>
      </select>
    </span>
  </div>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/potting-instructions/potting-instructions-form/potting-instructions-form.component.html